import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _Sprint } from '../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../theme/Component/Modal';
import { BasicTable } from '../../theme/Component/BasicTable';
import usePaginator from '../../theme/Component/usePaginator';

interface Props {
    label?: string;
    idSelector: number;
    onChange?: any;
    filterByState?: boolean;
}

export const EditorSprint = ({ idSelector, label, onChange, filterByState = true }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_Sprint);
    const paginador = usePaginator();

    const [modal, setModal] = useState<any>({ name: 'Buscar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        if (idSelector && typeof idSelector === 'number' && bean.IDWorkActivity != idSelector) {
            // instance.getWorkActivity(idSelector).then(
            //     (resp) => {
            //         onChange(resp);
            //         setBean(resp);
            //     }
            // ).catch(() => toast.error("No se pudo traer la información"));
        }
    }, [idSelector]);

    const getLista = () => {
        let props: any = filterByState ? { State: 2 } : {};

        instance.getSprintRender(paginador.page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);


                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityActivity = `${element.DataBeanProperties.WorkActivityCode ?? "N/P"}` + " " + `${element.DataBeanProperties.Name ?? "N/P"}`;
                });
                if (resp.List.length === 1) {
                    setBean(resp.List[0].DataBeanProperties)
                    onChange(resp.List[0].DataBeanProperties)
                }
                setLista(resp.List);
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDSprint', visible: true },
        { title: 'Nombre', property: 'SprintName', visible: true },
        { title: 'Fecha de Inicio', property: 'FromDate', visible: true },
        { title: 'Fecha de Finalizacion', property: 'UptoDate', visible: true },
    ];

    const selectItem = () => {
        let x = bean;
        setModal({ ...modal, "view": false });
        if (onChange) {
            onChange(x);
        }
    };

    useEffect(() => {
        getLista();
    }, []);


    return (
        <>
            {label && label != " " &&
                < label > {label ?? "Periodo de Trabajo"}</label>
            }
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={bean.IDSprint ? `${bean.SprintName}` : ""}
                onClick={() => { setModal({ ...modal, "view": true }) }}
            />

            <Modal modal={modal} updateModal={setModal} eventModal={() => { selectItem() }}>
                <BasicTable body={lista} head={head} rowSet={setBean} />
            </Modal>
        </>
    );
}
